<template>
  <div class="page">
    <mobileHeader title="钢瓶建档" rightType="none" @back="JS.close()" />
    <div class="form">
      <div class="form-item" v-for="(it, i) in formItem" :key="i">

        <template v-if="it.type == 'input'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value">
            <van-field
              v-model="post[it.prop]"
              :placeholder="it.placeholder?it.placeholder:('输入'+it.label)"
            />
          </div>
        </template>

        <!-- <template v-if="it.type == 'numberInput'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value">
            <van-field
              v-model="post[it.prop]"
              type="number"
              :placeholder="it.placeholder?it.placeholder:('输入'+it.label)"
            />
          </div>
        </template> -->

        <template v-if="it.type == 'inputSelect'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value" @click="popupCache(it.prop)">
            <van-field
              v-model="post[it.prop]"
              :placeholder="it.placeholder?it.placeholder:('输入或选择'+it.label)"
            />
            <div class="mask"></div>
          </div>
        </template>

        <template v-if="it.type == 'inputSelectNumber'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value" @click="popupCache(it.prop)">
            <van-field
              v-model="post[it.prop]"
              type="number"
              :placeholder="it.placeholder?it.placeholder:('输入或选择'+it.label)"
            />
            <div class="mask"></div>
          </div>
        </template>

        <template v-if="it.type == 'search'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value">
            <van-field
              v-model="post[it.prop]"
              :placeholder="it.placeholder?it.placeholder:('输入'+it.label)"
              @keyup.enter="searchCode(it.prop)"
            />
            <img class="search" @click="searchCode(it.prop)" src="@/assets/images/put-on-record/search.png" alt="">
          </div>
        </template>

        <template v-if="it.type == 'scanCode'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value">
            <van-field
              v-model="post[it.prop]"
              :placeholder="it.placeholder?it.placeholder:('输入'+it.label)"
            />
            <img class="search" @click="scanCode()" src="@/assets/images/put-on-record/scanCode.png" alt="">
          </div>
        </template>

        <template v-if="it.type == 'select'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value" @click.stop="setSelectList(i)">
            <van-field
              v-model="post[it.prop]"
              :placeholder="it.placeholder?it.placeholder:('输入'+it.label)"
            />
            <img class="search" src="@/assets/images/put-on-record/select.png" alt="">
            <div class="mask"></div>
          </div>
        </template>

        <template v-if="it.type == 'selectDate'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value" @click.stop="touchDate(it.prop)">
            <van-field
              v-model="post[it.prop]"
              :placeholder="it.placeholder?it.placeholder:('输入'+it.label)"
            />
            <img class="search" src="@/assets/images/put-on-record/select.png" alt="">
            <div class="mask"></div>
          </div>
        </template>

        <template v-if="it.type == 'disabled'">
          <div class="form-label">
            <img :src="it.img" alt=""> {{it.label}}：
          </div>
          <div class="form-value">
            <van-field
              v-model="post[it.prop]"
              :placeholder="it.placeholder?it.placeholder:('输入'+it.label)"
            />
            <div class="mask"></div>
          </div>
        </template>

      </div>
    </div>
    <div class="up-image">
      <div class="title">上传照片：</div>
      <!-- <div class="title">上传照片：<div class="del" @click="imgDel = !imgDel" :style="imgDel ? 'color: red' : ''">删除</div></div> -->
      <div class="push-img">
        <div class="image-item" v-for="(it, i) in post.imgs" :key="i">
          <img class="img" @click="ImagePreview({images: post.imgs, startPosition: i});" :src="it" alt="" />
          <div class="del" @click="delImg(i)"><van-icon name="cross" /></div>
        </div>
        <template v-if="post.imgs.length != 4">
          <div v-for="(it, i) in (4 - post.imgs.length)" :key="i + 'a'" class="image-item no-image" @click="(post.makeno == '') ? Toast('请先填写出厂编码') : (showSelectType = !showSelectType)">
            <img src="@/assets/images/put-on-record/pushImg.png" alt="">
          </div>

        </template>
        <!-- <div v-if="post.imgs.length != 4" class="image-item no-image" @click="(post.makeno == '') ? Toast('请先填写出厂编码') : (showSelectType = !showSelectType)">
          <img src="@/assets/images/put-on-record/pushImg.png" alt="">
        </div> -->
      </div>
    </div>
    <div class="sub-form">
      <div class="sub-button" @click="submit">保存</div>
    </div>
    <popupCache :options="popupCacheOptions" @selectVal="selectVal"></popupCache>
    <van-popup v-model="showSelectType">
      <div class="popup-cell-list">
        <div class="popup-cell" @click="scanCamera">拍照</div>
        <div class="popup-cell" @click="choosePhoto">相册中选择</div>
        <div class="popup-cell" style="background: #c0c0c0;color: #faf9f9" @click="showSelectType = false">取消</div>
      </div>
    </van-popup>
    <!-- 搜索出厂编码 内部编码 钢瓶二维码 -->
    <van-popup v-model="showSearch">
      <div class="search-list">
        <div class="select-item" v-for="(it, i) in searchList" :key="i" @click="selectItem(it)">{{it[searchKey]}}</div>
      </div>
    </van-popup>
    <van-popup v-model="showSelectList" position="bottom" v-if="selectAct">
      <div class="search-lists">
        <div class="select-item" v-for="(it, i) in formItem[selectAct].list" :key="i" @click="post[formItem[selectAct].prop] = it, showSelectList = false">{{it}}</div>
      </div>
    </van-popup>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        :type="selectDateType"
        title="请选择年月"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="confirmDate"
      />
    </van-popup>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import popupCache from "@/components/PopupCache"
import { airbottleSearch, airbottleCreate } from "@/api/flowPath"
import { Toast } from "vant";
import { ImagePreview } from 'vant';
let cachePost = "";
const moment = require("@/utils/moment.js")
export default {
  components: {
    mobileHeader,
    popupCache
  },
  data(){
    return {
      Toast,ImagePreview,
      imgDel: false,
      popupCacheOptions: {show: false, key: ""},
      post: {
        manufacturer: "",
        testunit: "",
        can_owner_key: "",
        makeno: "",
        jarno: "",
        bottle_id: "",
        specs: "",
        makedate: "",
        scrap_time: "",
        lastdate: "",
        test_time: "",
        workpressure: "",
        dimension: "",
        designthickness: "",
        empty_weight: "",
        imgs: []
      },
      formItem: [
        {
          prop: "manufacturer",
          label: "制造单位",
          type: "inputSelect",
          img: require('@/assets/images/put-on-record/manufacturer.png')
        },
        {
          prop: "testunit",
          label: "检验单位",
          type: "inputSelect",
          img: require('@/assets/images/put-on-record/testunit.png')
        },
        {
          prop: "can_owner_key",
          label: "产权归属",
          type: "select",
          list: ['自有', '托管'],
          img: require('@/assets/images/put-on-record/testunit.png')
        },
        {
          prop: "makeno",
          label: "出厂编码",
          type: "search",
          img: require('@/assets/images/put-on-record/makeno.png')
        },
        {
          prop: "jarno",
          label: "内部编码",
          type: "search",
          img: require('@/assets/images/put-on-record/jarno.png')
        },
        {
          prop: "bottle_id",
          label: "钢瓶二维码",
          type: "scanCode",
          img: require('@/assets/images/put-on-record/bottle_id.png'),
          placeholder: "扫码/输入二维码"
        },
        {
          prop: "specs",
          label: "钢瓶规格",
          type: "select",
          img: require('@/assets/images/put-on-record/specs.png'),
          list: ['5KG', '15KG', '50KG'],
          placeholder: "选择规格"
        },
        {
          prop: "makedate",
          label: "生产年月",
          type: "selectDate",
          img: require('@/assets/images/put-on-record/makedate.png'),
          placeholder: "选择年月"
        },
        {
          prop: "scrap_time",
          label: "报废年月",
          type: "disabled",
          img: require('@/assets/images/put-on-record/scrap_time.png'),
          placeholder: "根据生产年月自动计算"
        },
        {
          prop: "lastdate",
          label: "末次检验年月",
          type: "selectDate",
          img: require('@/assets/images/put-on-record/lastdate.png'),
          placeholder: "选择日期"
        },
        {
          prop: "test_time",
          label: "下次检验年月",
          type: "disabled",
          img: require('@/assets/images/put-on-record/test_time.png'),
          placeholder: "根据末次检验年月自动计算"
        },
        {
          prop: "workpressure",
          label: "公称工作压力",
          type: "inputSelect",
          img: require('@/assets/images/put-on-record/workpressure.png'),
        },
        {
          prop: "dimension",
          label: "容积",
          type: "inputSelect",
          img: require('@/assets/images/put-on-record/dimension.png'),
          placeholder: "输入钢瓶容积"
        },
        {
          prop: "designthickness",
          label: "设计壁厚",
          type: "inputSelect",
          img: require('@/assets/images/put-on-record/designthickness.png'),
          placeholder: "输入壁厚"
        },
        {
          prop: "empty_weight",
          label: "钢瓶自重",
          type: "inputSelectNumber",
          img: require('@/assets/images/put-on-record/empty_weight.png'),
          placeholder: "输入空瓶重量(KG),例如16.5"
        }

      ],
      // 搜索部分
      showSearch: false,
      searchList: [],
      searchKey: null,
      // 选择图片类型
      showSelectType: false,
      // 选择列表
      showSelectList: false,
      selectAct: null,
      // 选择年月日
      showDate: false,
      currentDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      minDate: new Date(1997, 1, 1),
      selectDateType: "date",
      dateProp: ""
    }
  },
  created(){
    this.createFn()
  },
  methods: {
    createFn(){
      const putOnRecord = this.mixGetCache("putOnRecord|", {workpressure: "", dimension: "", designthickness: "", empty_weight: ""})
      console.log(putOnRecord,"putOnRecord")
      Object.keys(putOnRecord).map(it => this.post[it] = putOnRecord[it])

    },
    scanCode(){
      this.mixScanCode(async ({data}) => {
        console.log(data, "建档扫码打印的内容")
        try{
          const ret = {
            bottleId: this.mixDecode(data)
          }
          
          if (!ret.bottleId)return Toast({ message: "请扫正确的二维码", duration: 500 })
          this.post.bottle_id = ret.bottleId
          // console.log(this.post)
          this.searchCode('bottle_id')
          
        }catch(error){
          return Toast({ message: "请扫正确的二维码", duration: 500});
        }
      });
    },
    scanCamera(){
      this.mixScanCamera(({data}) => {
        console.log(data, "建档拍照打印的内容")
        this.post.imgs.push(data)
        this.showSelectType = false
      }, this.post.makeno)
    },
    choosePhoto(){
      this.mixChoosePhoto(({data}) => {
        console.log(data, "建档选择相册打印的内容")
        this.post.imgs.push(data)
        this.showSelectType = false
      }, this.post.makeno)
    },
    delImg(i){
      let imgs = this.post.imgs
      imgs.splice(i, 1)
      this.post.imgs = imgs
    },
    // 选择或者输入缓存的数据
    popupCache(key){
      this.popupCacheOptions = {show: true, key, value: this.post[key]}
    },
    selectVal({val, key}){
      console.log(val, key,"val, key")
      this.popupCacheOptions.show = false
      this.post[key] = val
    },
    // 搜索出厂编码 内部编码 钢瓶二维码
    async searchCode(key){
      if(this.post[key].length < 4)return Toast("至少输入4位字符")
      let {code, msg, data} = await airbottleSearch({[key]: this.post[key]})
      if(code != 200)return Toast(msg)
      if(key == "bottle_id"){
        data = data.filter(it => it.bottle_id == this.post[key])
      }
      if(data.length == 0)return Toast("暂无数据")
      data = data.map(it => {
        it.imgs = it.pics.map(it => it.airbottle_pic)
        return it
      })
      if(data.length == 1)return this.selectItem(data[0])
      console.log(data,"data")
      
      this.searchList = data
      this.showSearch = true
      this.searchKey = key
    },
    selectItem(item){
      const keys = Object.keys(this.post)
      console.log(keys)
      console.log(item)
      keys.map(it => {
        if(it == 'imgs')return (this.post[it] = item[it] || [])
        if(it == 'scrap_time' && item[it] && item[it].length == 10)return (this.post[it] = item[it].substring(0, 7))
        if(it == 'lastdate' && item[it] && item[it].length == 10)return (this.post[it] = item[it].substring(0, 7))
        if(it == 'test_time' && item[it] && item[it].length == 10)return (this.post[it] = item[it].substring(0, 7))
        this.post[it] = (item[it] || "")
      })
      if(item.scrap_time != "" && item.test_time != ""){
        Number(new Date(item.scrap_time)) < Number(new Date(item.test_time)) && (this.post.test_time = "")
      }
      cachePost = JSON.stringify(this.post)
      this.showSearch = false
    },
    // 规格选择
    setSelectList(index){
      this.selectAct = index
      this.showSelectList = true

    },
    // 选择日期
    touchDate(prop){
      if(this.post[prop] != ""){
        this.currentDate = new Date(this.post[prop])
      }
      this.dateProp = prop
      this.showDate = true
      const obj = {
        makedate: "year-month",
        lastdate: "year-month",
      }
      this.selectDateType = obj[prop]
    },
    confirmDate(val){
      const obj = {
        makedate: "YYYY-MM",
        lastdate: "YYYY-MM",
      }
      
      this.post[this.dateProp] = moment(val).format(obj[this.dateProp])
      
      // 计算报废时间
      if(this.dateProp == 'makedate'){
        this.post.scrap_time = moment(val).add(12, 'y').format(obj[this.dateProp])
      }

      // 计算检测时间
      if(this.dateProp == 'lastdate'){
        this.post.test_time = moment(val).add(4, 'y').format(obj[this.dateProp])
      }
      if(this.post.makedate != "" && this.post.lastdate != ""){
         if(Number(new Date(this.post.scrap_time)) < Number(new Date(this.post.test_time))){
           this.post.test_time = ""
         }else{
          this.post.test_time = moment(this.post.lastdate).add(4, 'y').format('YYYY-MM')
         }
      }
      this.showDate = false
    },
    // 提交表单
    async submit(){
      const post = {...this.post}
      if(post.can_owner_key == "")return Toast("请选择产权归属")
      if(post.makeno == "")return Toast("出厂编码不能为空")
      if(post.jarno == "")return Toast("内部编码不能为空")
      if(post.bottle_id == "")return Toast("钢瓶二维码不能为空")
      if(post.makedate == "")return Toast("请选择生产年月")
      if(cachePost == JSON.stringify(post))return Toast("无更新数据")
      post.lastdate && (post.lastdate = post.lastdate)
      post.test_time && (post.test_time = post.test_time)
      post.can_owner = (post.can_owner_key == "自有" ? 1 : 2);
      const {code, msg} = await airbottleCreate(post)
      
      if(code != 200)return Toast(msg);

      this.cacheItem('manufacturer')
      this.cacheItem('testunit')
      this.cacheItem('workpressure')
      this.cacheItem('dimension')
      this.cacheItem('designthickness')
      this.cacheItem('empty_weight')

      this.mixSetCache("putOnRecord|", {manufacturer: post.manufacturer, testunit: post.testunit, workpressure: post.workpressure, dimension: post.dimension, designthickness: post.designthickness, empty_weight: post.empty_weight})
      Toast("保存成功")
      // setTimeout(_=>this.$router.go(-1), 1000)
      setTimeout(_=>{
        this.post = {
          manufacturer: "",
          testunit: "",
          makeno: "",
          jarno: "",
          bottle_id: "",
          specs: "",
          makedate: "",
          scrap_time: "",
          lastdate: "",
          test_time: "",
          workpressure: "",
          dimension: "",
          designthickness: "",
          empty_weight: "",
          imgs: []
        }
        this.createFn()
      }, 1000)
    },
    cacheItem(key){
      const val = this.post[key]
      console.log(val)
      let cacheList = this.mixGetCache('putOnRecordCache|' + key, [])
      console.log(cacheList,"cacheList")
      const findIndex = cacheList.findIndex(it => it == val)
      findIndex != -1 && cacheList.splice(findIndex, 1);
      cacheList.unshift(val)
      cacheList.splice(10)
      this.mixSetCache("cache|" + key, cacheList)
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.page{
  .form{
    margin: 3.5vw 3.8vw;
    .form-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .form-label{
        display: flex;
        align-items: center;
        font-size: 4.2vw;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #575454;
        img{
          width: 7.5vw;
          height: 7.5vw;
          margin-right: 1.8vw;
        }
      }
      .form-value{
        width: 46.1vw;
        height: 9vw;
        border: 1px solid #898989;
        border-radius: 1.4vw;
        overflow: hidden;
        display: flex;
        padding: 0 2vw;
        align-items: center;
        position: relative;
        .mask{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        ::v-deep .van-cell{
          padding: 0;
          font-size: 3.6vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          input::placeholder{
            color: #8F8F8F!important;
          }
          
        }
        ::v-deep .van-field__control:disabled{
          -webkit-text-fill-color:#8F8F8F!important;
        }
        .search{
          width: 6.1vw;
          height: 6.1vw;
        }
        .van-cell::after{
          display: none;
        }
      }
    }
    .form-item + .form-item{
      margin-top: 4vw;
    }
  }
  .up-image{
    border-top: 0.8vw solid #f7f7f7;
    .title{
      margin: 0 3.9vw;
      margin-top: 2.8vw;
      font-size: 4.2vw;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #575454;
      display: flex;
      justify-content: space-between;
      .del{
        font-size: 3vw;
        transition: all 0.2s;
      }
      .del:active{
        transform: scale(1.2);
      }
    }
    .push-img{
      margin-bottom: 4.5vw;
      margin-left: 5.4vw;
      display: flex;
      flex-wrap: wrap;
      .image-item{
        width: 16.7vw;
        height: 14.4vw;
        display: inline-flex;
        margin: 2.5vw;
        position: relative;
        border-radius: 1.4vw;
        overflow: hidden;
        .img{
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
        .del{
          position: absolute;
          width: 4vw;
          height: 4vw;
          top: 0;
          right: 0;
          background: red;
          border-radius: 50%;
          z-index: 88;
          color: white;
          font-size: 4vw;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        // .del{
        //   position: absolute;
        //   width: 100%;
        //   height: 100%;
        //   top: 0;
        //   left: 0;
        //   display: flex;
        //   justify-content: center;
        //   align-items: center;
        //   font-size: 4vw;
        //   color: red;
        //   background: #8989897a;
        // }
      }
      .no-image{
        justify-content: center;
        align-items: center;
        border: 1px solid #BFBFBF;
        background: #EEEEEE;
        border-radius: 1.4vw;
        img{
          width: 5vw;
          height: 5vw;
        }
      }

    }

  }
  .sub-form{
    height: 25vw;
    background: #f7f7f7;
    padding-top: 5.6vw;
    .sub-button{
      width: 78.3vw;
      line-height: 13.9vw;
      background: #2E8DFF;
      border-radius: 1.4vw;
      margin: auto;
      text-align: center;
      font-size: 5.5vw;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      transition: all 0.1s;
    }
    .sub-button:active{
      transform: scale(0.96);
    }
  }
  .popup-cell-list{
    width: 90vw;
    background: #f0f0f0;
    padding: 6vw 10vw;
    box-sizing: border-box;
  }
  .popup-cell{
    line-height: 11vw;
    text-align: center;
    color: #7f7f7f;
    font-size: 6vw;
    background: #f6f6f6;
    border-radius: 1vw;
    border: 2px solid #cececa;
  }
  .popup-cell + .popup-cell{
    margin-top: 4vw;
  }
  .popup-cell:active{
    background: #e7e7e7;
  }
}
.search-list{
  width: 80vw;
  height: 60vh;
  padding: 3vw;
  text-align: center;
  .select-item{
    border: 1px solid #ccc;
    margin: 2vw 0;
    line-height: 18vw;
    font-size: 5vw;
    border-radius: 1vw;
    transition: all 0.1s;
  }
  .select-item:active{
    transform: scale(0.96);
  }
}
.search-lists{
  text-align: center;
  .select-item{
    line-height: 18vw;
    font-size: 5vw;
    transition: all 0.1s;
  }
  .select-item + .select-item{
    border-top: 1px solid #ccc;
  }
  .select-item:active{
    background: #e7e7e7;
  }
  
}

::v-deep .van-popup--center{
  border-radius: 1vw;
}

</style>